module.exports = __webpack_public_path__ + "img/esmeralda.168a3e78.png";